import ApplicationsModule from '@features/Applications/Applications.Module';

const Applications = () => {
  return <ApplicationsModule />;
};

export default Applications;
